export default __webpack_public_path__ + "static/media/Icons_Boat_Icon_Blue.9df9f330.svg";